const doc = [({"en":({"js":({"admin":({"photo_qualities":({"create_card":({"create_photo_quality":"Create photo quality"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;